<template>
  <intersect @enter="animate = true">
    <section
      class="head-banner directBanner fadeUp"
      :class="animate ? 'animate' : ''"
    >
      <div class="img-box parallaxe">
        <picture>
          <source
            media="(max-width: 767px)"
            :srcset="_.get(itemData[0], 'cover_image.0.devices.mobile')"
          />
          <source
            media="(max-width: 1023px)"
            :srcset="_.get(itemData[0], 'cover_image.0.devices.tablet')"
          />
          <img
            v-if="_.get(itemData[0], 'cover_image')"
            :src="_.get(itemData[0], 'cover_image.0.devices.desktop')"
            class="img-absolute"
            alt=""
            v-prlx="{ speed: 0.08 }"
          />
        </picture>
        <div class="img-overlay"></div>
      </div>
      <div class="directBannerTtl">
        <div class="ttl">{{ _.get(itemData, "0.title") }}</div>
        <div class="descr">{{ _.get(itemData, "0.teaser") }}</div>
        <a
          v-if="_.get(itemData, '0.smartbuttons')"
          :href="`:tel` + `${_.get(itemData, '0.smartbuttons.0.url')}`"
          class="btn"
        >
          {{ _.get(itemData, "0.smartbuttons.0.title") }}
        </a>
      </div>
    </section>
  </intersect>
</template>

<script>
import Vue from "vue";
import MainMixin from "@/mixins/ali";
import Intersect from "vue-intersect";
import Paralax from "@/assets/js/paralax.js";
Vue.directive("prlx", Paralax);

export default {
  props: {
    itemData: {
      type: Array,
      require: true
    }
  },
  components: {
    Intersect
  },
  data() {
    return {
      animate: false
      // ButtonUrl: _.get(itemData, '0.buttons.0.url'),
      // ImageUrl: _.get(itemData, '0.cover_image.0.url')
    };
  },
  mixins: [MainMixin],
  mounted() {
    this.startParralaxe();
  },
  computed: {
    // getDirectCall(){
    //     return this.$store.getters.getDirectCall
    // },
  }
};
</script>
